/* eslint-disable consistent-return */

import { Mongo } from 'meteor/mongo';
import SimpleSchema from 'simpl-schema';
import { wsRegex } from '../../modules/regex-utils';

const ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

const TelemetryConnections = new Mongo.Collection('TelemetryConnections');

TelemetryConnections.allow({
  insert: () => false,
  update: () => false,
  remove: () => false
});

TelemetryConnections.deny({
  insert: () => true,
  update: () => true,
  remove: () => true
});

TelemetryConnections.schema = new SimpleSchema({
  owner: {
    type: String,
    label: 'The ID of the user this telemetry connection belongs to.'
  },
  createdAt: {
    type: String,
    label: 'The date this telemetry connection was created in the database.',
    autoValue() {
      if (this.isInsert) return new Date().toISOString();
    }
  },
  updatedAt: {
    type: String,
    label: 'The date this telemetry connection was last updated.',
    autoValue() {
      if (this.isInsert || this.isUpdate) return new Date().toISOString();
    }
  },
  name: {
    type: String,
    label: 'A name to identify the telemetry connection.'
  },
  url: {
    type: String,
    regEx: wsRegex,
    label: 'The url for the telemetry connection',
    optional: true
  },
  domain: {
    type: String,
    label: 'The domain, included protocol for the server connection',
    optional: true
  },
  ip: {
    type: String,
    regEx: ipRegex,
    label: 'The ip for the telemetry connection',
    optional: true
  },
  port: {
    type: Number,
    label: 'The port for the telemetry connection',
    optional: true
  },
  serverType: {
    type: String,
    label:
      'The server Type, so far GMS/SGMS (GeoMicroServices) and DSL/SDSL (Database Server Layer)',
    optional: true
  },
  selected: {
    type: Boolean,
    label: 'Flag to check which telemetry connection to use',
    autoValue() {
      if (this.isInsert) return false;
    }
  }
});

TelemetryConnections.attachSchema(TelemetryConnections.schema);

export default TelemetryConnections;
